import React from 'react';
import { Check, X, Lightbulb, TrendingUp } from 'lucide-react';
import { NuriCompanion } from '@/components/NuriCompanion';

export function ConfirmedView({ showCoachingCard, coachingReview, navigate }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] animate-fade-in-up" data-testid="meal-confirmed-phase">
      {!showCoachingCard && (
        <>
          <NuriCompanion state="excited" size="lg" />
          <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: 24, fontWeight: 400, color: '#1A1A18', marginTop: 12 }}>Meal Logged!</h2>
          <p style={{ fontSize: 13, color: '#9A9590', fontFamily: 'var(--font-sans)', marginTop: 8 }}>
            {coachingReview ? 'Generating your coaching review...' : 'Returning to dashboard...'}
          </p>
        </>
      )}

      {showCoachingCard && coachingReview && (
        <div data-testid="coaching-card" style={{ width: '100%', maxWidth: 420, margin: '0 auto', animation: 'slideUpSpring 0.5s ease-out' }}>
          <div className="nuri-card-3d" style={{ padding: 20, position: 'relative' }}>
            <button data-testid="coaching-card-dismiss" onClick={() => navigate('/dashboard')}
              style={{ position: 'absolute', top: 12, right: 12, padding: 6, background: 'none', border: 'none', cursor: 'pointer' }}>
              <X className="w-4 h-4" style={{ color: '#9A9590' }} />
            </button>

            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: coachingReview.grade?.startsWith('A') ? '#5A8C6A15' :
                            coachingReview.grade?.startsWith('B') ? '#4A90D915' :
                            coachingReview.grade?.startsWith('C') ? '#E5A84B15' : '#C67A5C15',
              }}>
                <span style={{
                  fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-serif)',
                  color: coachingReview.grade?.startsWith('A') ? '#5A8C6A' :
                         coachingReview.grade?.startsWith('B') ? '#4A90D9' :
                         coachingReview.grade?.startsWith('C') ? '#E5A84B' : '#C67A5C',
                }}>{coachingReview.grade || 'B'}</span>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, color: '#9A9590', fontFamily: 'var(--font-sans)' }}>Nuri's Take</p>
                <p style={{ margin: '2px 0 0', fontSize: 12, color: '#6A6560', fontFamily: 'var(--font-sans)' }}>{coachingReview.grade_explanation}</p>
              </div>
            </div>

            <p data-testid="coaching-quick-message" style={{ margin: '0 0 16px', padding: 14, borderRadius: 14, background: '#F5F0E8', fontSize: 14, lineHeight: 1.5, color: '#1A1A18', fontFamily: 'var(--font-sans)' }}>
              {coachingReview.quick_coaching}
            </p>

            {coachingReview.swap_suggestion && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 12 }}>
                <div style={{ width: 28, height: 28, borderRadius: 8, background: '#C67A5C12', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2 }}>
                  <Lightbulb className="w-3.5 h-3.5" style={{ color: '#C67A5C' }} />
                </div>
                <p style={{ margin: 0, fontSize: 12, color: '#6A6560', fontFamily: 'var(--font-sans)', lineHeight: 1.4 }}>
                  <span style={{ fontWeight: 600, color: '#C67A5C' }}>Next time: </span>
                  {coachingReview.swap_suggestion}
                </p>
              </div>
            )}

            {coachingReview.positive_reinforcement && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 16 }}>
                <div style={{ width: 28, height: 28, borderRadius: 8, background: '#5A8C6A12', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2 }}>
                  <TrendingUp className="w-3.5 h-3.5" style={{ color: '#5A8C6A' }} />
                </div>
                <p style={{ margin: 0, fontSize: 12, color: '#6A6560', fontFamily: 'var(--font-sans)', lineHeight: 1.4 }}>
                  {coachingReview.positive_reinforcement}
                </p>
              </div>
            )}

            <button data-testid="coaching-card-continue" onClick={() => navigate('/dashboard')}
              style={{ width: '100%', padding: 14, borderRadius: 28, border: 'none', cursor: 'pointer', background: '#1A1A18', color: '#FFF', fontSize: 14, fontWeight: 500, fontFamily: 'var(--font-sans)' }}>
              Continue to Dashboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
